import React from 'react';

/**
 * Componente de carga inteligente que se adapta según el contexto
 */
const SmartLoader = ({ 
  isVisible = false,
  message = "Cargando...",
  subtitle = null,
  minimal = false,
  showSpinner = true,
  className = ""
}) => {
  if (!isVisible) return null;

  // Versión minimal para navegación entre páginas
  if (minimal) {
    return (
      <div className={`fixed top-4 right-4 z-50 ${className}`}>
        <div className="bg-gray-800 rounded-lg shadow-lg p-3 flex items-center space-x-2">
          {showSpinner && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
          )}
          <span className="text-gray-300 text-sm">{message}</span>
        </div>
      </div>
    );
  }

  // Versión completa para carga inicial
  return (
    <div className={`min-h-screen flex items-center justify-center bg-gray-900 ${className}`}>
      <div className="text-center">
        {showSpinner && (
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        )}
        <p className="text-gray-300 text-lg">{message}</p>
        {subtitle && (
          <p className="text-gray-500 text-sm mt-2">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default SmartLoader;